import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./BackButton.module.css";
var BackButton = function BackButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("button", {
    className: "".concat(stl.backButton, " ").concat(className ? className : ""),
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrow_right.svg",
    alt: ""
  }), children);
};
export default BackButton;